export default __webpack_public_path__ + "static/media/Diana-Banner-Download.81d85792.png";